import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-world.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const WorldIcon = createSvgIcon(<Icon />, 'WorldIcon');
